<template lang="pug">
  div(class="data-block")
    history
    div(class="flex")
      age(class="item")
      action-area(class="item")
    div(class="flex")
      reply
    div(class="flex")
      project-area(class="item")
      project(class="item")
    project-area-by-region(class="projectAreaByRegion")
    div(class="note") 2020年1月時点のデータをもとに算出しています
</template>
<script>
  import ActionArea from 'modules/components/Event/Infographics/Area.vue';
  import Age from 'modules/components/Event/Infographics/Age.vue';
  import History from 'modules/components/Event/Infographics/History.vue';
  import Project from 'modules/components/Event/Infographics/Project.vue';
  import ProjectArea from 'modules/components/Event/Infographics/ProjectArea.vue';
  import ProjectAreaByRegion from 'modules/components/Event/Infographics/ProjectAreaByRegion.vue';
  import Reply from 'modules/components/Event/Infographics/Reply.vue';

  export default {
    components: {
      ActionArea,
      Age,
      History,
      Project,
      ProjectArea,
      ProjectAreaByRegion,
      Reply,
    },
  };
</script>
<style lang="scss" scoped>
  .data-block {
    padding-bottom: 90px;
  }
  .flex {
    max-width: 940px;
    padding-bottom: 60px;
    margin-left: auto;
    margin-right: auto;
    @include mq('sm') {
      display: flex;
      align-items: flex-start;
      justify-content: center;
      padding-bottom: 100px;
    }
  }
  .item {
    flex: 0 1 50%;
    margin-left: auto;
    margin-right: auto;
    @include mq('sp') {
      & + & {
        padding-top: 60px;
      }
    }
  }
  .projectArea {
    padding-top: 100px;
  }
  .projectAreaByRegion {
    padding-top: 100px;
  }
  .note {
    font-size: 1.2rem;
    text-align: right;
    padding-right: 10px;
    margin-top: 20px;
    @include mq('sm') {
      font-size: 1.4rem;
      padding-right: 20px;
    }
    @include mq {
      font-size: 1.6rem;
    }
  }
</style>
